var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueloc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 8.58464C5.44682 8.58464 4.91691 8.36514 4.52621 7.97444C4.13551 7.58374 3.91602 7.05384 3.91602 6.5013C3.91602 5.94877 4.13551 5.41886 4.52621 5.02816C4.91691 4.63746 5.44682 4.41797 5.99935 4.41797C6.55188 4.41797 7.08179 4.63746 7.47249 5.02816C7.86319 5.41886 8.08268 5.94877 8.08268 6.5013C8.08268 6.77489 8.0288 7.0458 7.9241 7.29856C7.8194 7.55132 7.66594 7.78099 7.47249 7.97444C7.27903 8.1679 7.04937 8.32135 6.79661 8.42605C6.54385 8.53075 6.27294 8.58464 5.99935 8.58464ZM5.99935 0.667969C4.45225 0.667969 2.96852 1.28255 1.87456 2.37651C0.780597 3.47047 0.166016 4.95421 0.166016 6.5013C0.166016 10.8763 5.99935 17.3346 5.99935 17.3346C5.99935 17.3346 11.8327 10.8763 11.8327 6.5013C11.8327 4.95421 11.2181 3.47047 10.1241 2.37651C9.03018 1.28255 7.54645 0.667969 5.99935 0.667969Z",
    fill: "#4D94FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueloc);
export default __webpack_public_path__ + "static/media/BLUELOC.285e4c1e1f0849325be4609ec2bf93ac.svg";
export { ForwardRef as ReactComponent };